/**
 * Locations (Full data)
 * Locations (Minimal data)
 *
 * GET_LIST
 */
export const RESOURCES = {
    "Locations": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v5/report/location/" + system + "/getAll?params=" + JSON.stringify(params)
            }
        }
    },
    "LocationsMin": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v5/report/locationMinInfo/" + system + "/getAll"
            }
        }
    },
    "LocationTypes": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v5/report/locationType/" + system + "/getAll"
            }
        }
    },
    "LocationCities": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "Location Cities by System",
                "uri": localStorage.getItem('server') + "/api/v5/search/q/" + system + "/locReports/getAllLocationCities"
            }
        }
    },
    "DBAs": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "DBAs by System",
                "uri": localStorage.getItem('server') + "/api/v5/report/dba/" + system + "/getAll"
            }
        }
    },
    "Districts": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "Districts by System",
                "uri": localStorage.getItem('server') + "/api/v5/report/district/" + system + "/getAll"
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "Locations"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseLocationsResourceMap.js